var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronDoubleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle-double-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99983 8.74969C6.90129 8.75015 6.80365 8.73093 6.71264 8.69315C6.62162 8.65537 6.53907 8.5998 6.46983 8.52969C6.32938 8.38906 6.25049 8.19844 6.25049 7.99969C6.25049 7.80094 6.32938 7.61031 6.46983 7.46969L9.46983 4.46969L6.46983 1.46969C6.39968 1.32441 6.37824 1.16039 6.40869 1.00197C6.43915 0.843546 6.51987 0.699165 6.63889 0.590256C6.7579 0.481348 6.90886 0.413717 7.06936 0.397401C7.22985 0.381085 7.39133 0.416955 7.52983 0.499686L11.0298 3.99969C11.1703 4.14031 11.2492 4.33093 11.2492 4.52969C11.2492 4.72844 11.1703 4.91906 11.0298 5.05969L7.52983 8.49969C7.46316 8.57525 7.38177 8.6364 7.29063 8.67939C7.19949 8.72237 7.10054 8.7463 6.99983 8.74969Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.50006 8.74998C1.30712 8.73523 1.12763 8.64548 1.00006 8.49998C0.877076 8.36248 0.809082 8.18446 0.809082 7.99998C0.809082 7.8155 0.877076 7.63749 1.00006 7.49998L4.00006 4.49998L1.00006 1.49998C0.933224 1.36003 0.911416 1.20279 0.937643 1.04993C0.96387 0.89707 1.03684 0.756097 1.14651 0.646428C1.25618 0.536759 1.39715 0.463787 1.55001 0.43756C1.70288 0.411333 1.86011 0.433141 2.00006 0.499982L5.50006 3.99998C5.64052 4.14061 5.71941 4.33123 5.71941 4.52998C5.71941 4.72873 5.64052 4.91936 5.50006 5.05998L2.00006 8.49998C1.8725 8.64548 1.69301 8.73523 1.50006 8.74998Z",
    fill: "#F8F9FA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDoubleRight);
export default __webpack_public_path__ + "static/media/icon-chevron-double-right.fbcdb94f350fe6b9459a8b439271de6c.svg";
export { ForwardRef as ReactComponent };